import {ActionsTitle, CardsGrid, MainTitle, ModalContainer, Tab} from './styles';
import {SendProjectModalWrapper} from "./employStyles";
import {FC, useCallback, useEffect, useState} from "react";
import {useProfile} from "@brg/auth";
import {FlexBox, useBreakpoint, useIsMobile, useToasts} from "@brg/ui";
import {SendProjectButton} from "../../../_competition/components/SendProjectButton";
import {useTranslation} from "react-i18next";
import {ShopCard} from "../../pages/Shop/ShopCard";
import {LayoutConst, useModal} from "../../../core";
import {useGetLongreadProducts} from "../../hooks/api/Shop/useGetLongreadProducts";
import {API, Endpoints} from "@brg/api";
import {useGetAllProducts} from "../../hooks/api/Shop/useGetAllProducts";


export const SendBrndItemModal: FC<{project: any}> = ({project}) => {

    const profile = useProfile()
    const isMobile = useIsMobile();
    const is744 = useBreakpoint(LayoutConst.screen.s);
    const { t } = useTranslation();
    const toast = useToasts()
    const modal = useModal()

    const [products, isProductsLoading] = useGetLongreadProducts(project?.longreadId || "");
    const [selectedProducts, setSelectedProducts] = useState<string[]>([]);
    const [allProducts, isAllProductsLoading] = useGetAllProducts(1, 20);

    useEffect(() => {
        setSelectedProducts(products?.map((product: any) => product?.entityId) || [])
    }, [products])

    // @ts-ignore
    const selectProduct = useCallback((cardId, selected) => {
        setSelectedProducts(selected ? selectedProducts?.filter(id => id !== cardId) : [...selectedProducts, cardId]);
    }, [selectedProducts])

    const onSubmit = useCallback(() => {

        const prevProductsIds = products?.map((product: any) => product?.entityId) || [];
        const deletedProducts = prevProductsIds?.filter((productId: any) => !selectedProducts?.includes(productId)) || [];
        const addedProducts = selectedProducts?.filter((productId: any) => !products?.includes(productId)) || [];
        const operationProducts = [...deletedProducts.map((productId: any) => ({
            cardId: productId,
            operation: 0,
        })), ...addedProducts.map((productId: any) => ({
            cardId: productId,
            operation: 1,
        }))];

                API.request()
                    .endpoint(Endpoints.longread)
                    .url('/api/Longread/UpdateProducts')
                    .post()
                    .body({longreadId: project?.longreadId, cards: operationProducts})
                    .send()
                    .then((r) => r.json())
                    .then((r) => {toast.info('Товары добавлены'); window.location.reload()})
                    .catch((e) => console.error(e))
        modal.hide()
    }, [selectedProducts, products, project])

    if (!profile || isProductsLoading || isAllProductsLoading) {
        return null;
    }

    return <ModalContainer style={{overflow: is744 ? 'auto' : 'visible', padding: is744 ? '24px 0 48px 0' : '0', width: '100%', justifyContent: 'center'}}>
        <SendProjectModalWrapper directionMobile='column' direction='column' justify={'flex-start'} align={"center"} style={{ position: 'relative'}}>
            <ActionsTitle justify='space-between' justifyMobile='flex-start' direction='row'>
                <FlexBox direction='row' width={'100%'}>
                    <MainTitle>
                        {t('shop.select_card')}
                    </MainTitle>
                </FlexBox>
                {!is744 && <FlexBox>
                    <SendProjectButton width={185} onClick={onSubmit}>
                        {t('shop.attach')}
                    </SendProjectButton>
                </FlexBox>}
            </ActionsTitle>
            <FlexBox justify="space-between"  offsetBottom={24} offsetBottomMobile={is744 ? 16 : 24} width={'100%'}>
                <FlexBox gx={24}>
                    {!isMobile && <Tab>{t('shop.cards')}</Tab>}
                    <Tab>{t('shop.selected_cards') + ` ${selectedProducts?.length || 0}`}</Tab>
                </FlexBox>
            </FlexBox>
            <CardsGrid>
                {allProducts?.data?.map((value: any) => (
                    // @ts-ignore
                    <ShopCard selected={selectedProducts.includes(value?.entityId)} customClick={() => selectProduct(value?.entityId, selectedProducts.includes(value?.entityId))} isSmall
                        key={value?.entityId} id={value?.entityId} images={value?.images} name={value?.name} price={value?.price}/>
                ))}
            </CardsGrid>
            {is744 && <FlexBox width={'100%'} offsetBottom={70} offsetTop={32}>
                <SendProjectButton fullWidth onClick={onSubmit}>
                    {t('shop.attach')}
                </SendProjectButton>
            </FlexBox>}
            <div/>
        </SendProjectModalWrapper>
    </ModalContainer>
}import {ActionsTitle, CardsGrid, MainTitle, ModalContainer, Tab} from './styles';
import {SendProjectModalWrapper} from "./employStyles";
import {FC, useCallback, useEffect, useState} from "react";
import {useProfile} from "@brg/auth";
import {FlexBox, useBreakpoint, useIsMobile, useToasts} from "@brg/ui";
import {SendProjectButton} from "../../../_competition/components/SendProjectButton";
import {useTranslation} from "react-i18next";
import {ShopCard} from "../../pages/Shop/ShopCard";
import {LayoutConst, useModal} from "../../../core";
import {useGetLongreadProducts} from "../../hooks/api/Shop/useGetLongreadProducts";
import {API, Endpoints} from "@brg/api";
import {useGetAllProducts} from "../../hooks/api/Shop/useGetAllProducts";


export const SendBrndItemModal: FC<{project: any}> = ({project}) => {

    const profile = useProfile()
    const isMobile = useIsMobile();
    const is744 = useBreakpoint(LayoutConst.screen.s);
    const { t } = useTranslation();
    const toast = useToasts()
    const modal = useModal()

    const [products, isProductsLoading] = useGetLongreadProducts(project?.longreadId || "");
    const [selectedProducts, setSelectedProducts] = useState<string[]>([]);
    const [allProducts, isAllProductsLoading] = useGetAllProducts(1, 20);

    useEffect(() => {
        setSelectedProducts(products?.map((product: any) => product?.entityId) || [])
    }, [products])

    // @ts-ignore
    const selectProduct = useCallback((cardId, selected) => {
        setSelectedProducts(selected ? selectedProducts?.filter(id => id !== cardId) : [...selectedProducts, cardId]);
    }, [selectedProducts])

    const onSubmit = useCallback(() => {

        const prevProductsIds = products?.map((product: any) => product?.entityId) || [];
        const deletedProducts = prevProductsIds?.filter((productId: any) => !selectedProducts?.includes(productId)) || [];
        const addedProducts = selectedProducts?.filter((productId: any) => !products?.includes(productId)) || [];
        const operationProducts = [...deletedProducts.map((productId: any) => ({
            cardId: productId,
            operation: 0,
        })), ...addedProducts.map((productId: any) => ({
            cardId: productId,
            operation: 1,
        }))];

                API.request()
                    .endpoint(Endpoints.longread)
                    .url('/api/Longread/UpdateProducts')
                    .post()
                    .body({longreadId: project?.longreadId, cards: operationProducts})
                    .send()
                    .then((r) => r.json())
                    .then((r) => {toast.info('Товары добавлены'); window.location.reload()})
                    .catch((e) => console.error(e))
        modal.hide()
    }, [selectedProducts, products, project])

    if (!profile || isProductsLoading || isAllProductsLoading) {
        return null;
    }

    return <ModalContainer style={{overflow: is744 ? 'auto' : 'visible', padding: is744 ? '24px 0 48px 0' : '0', width: '100%', justifyContent: 'center'}}>
        <SendProjectModalWrapper directionMobile='column' direction='column' justify={'flex-start'} align={"center"} style={{ position: 'relative'}}>
            <ActionsTitle justify='space-between' justifyMobile='flex-start' direction='row'>
                <FlexBox direction='row' width={'100%'}>
                    <MainTitle>
                        {t('shop.select_card')}
                    </MainTitle>
                </FlexBox>
                {!is744 && <FlexBox>
                    <SendProjectButton width={185} onClick={onSubmit}>
                        {t('shop.attach')}
                    </SendProjectButton>
                </FlexBox>}
            </ActionsTitle>
            <FlexBox justify="space-between"  offsetBottom={24} offsetBottomMobile={is744 ? 16 : 24} width={'100%'}>
                <FlexBox gx={24}>
                    {!isMobile && <Tab>{t('shop.cards')}</Tab>}
                    <Tab>{t('shop.selected_cards') + ` ${selectedProducts?.length || 0}`}</Tab>
                </FlexBox>
            </FlexBox>
            <CardsGrid>
                {allProducts?.data?.map((value: any) => (
                    // @ts-ignore
                    <ShopCard selected={selectedProducts.includes(value?.entityId)} customClick={() => selectProduct(value?.entityId, selectedProducts.includes(value?.entityId))} isSmall
                        key={value?.entityId} id={value?.entityId} images={value?.images} name={value?.name} price={value?.price}/>
                ))}
            </CardsGrid>
            {is744 && <FlexBox width={'100%'} offsetBottom={70} offsetTop={32}>
                <SendProjectButton fullWidth onClick={onSubmit}>
                    {t('shop.attach')}
                </SendProjectButton>
            </FlexBox>}
            <div/>
        </SendProjectModalWrapper>
    </ModalContainer>
}